export enum Pages {
  ADMIN_CREATE_CONTRACT,
  ADMIN_CREATE_PRODUCT_CATEGORY,
  ADMIN_PRODUCT_CATEGORY,
  ADMIN_PRODUCT_CATEGORY_SUBCATEGORY,
  ADMIN_PRODUCT_CATEGORY_SUBCATEGORIES,
  BULLETIN_BOARD,
  CATALOG_CATEGORIES,
  CATALOG_PRODUCTS,
  CATALOG_PRODUCTS_VIEW,
  COMPARE_OFFERS,
  COMPANY_SETTINGS_AGREEMENTS,
  COMPANY_SETTINGS_DIRECTORY,
  COMPANY_SETTINGS_MANAGE_USERS,
  COMPANY_SETTINGS_PROFILE,
  GROUP_PROFLE,
  CREATE,
  MANAGE,
  MEASURMENT_CATEGORY,
  MEASURMENT_DETAILS,
  MEASURMENT_PARTICIPANTS,
  MEASURMENT_PRODUCTS,
  MEASUREMENT_SELLERS,
  OPPORTUNITIES,
  PARTICIPANTS_IMPACT,
  REVIEW_CONTRACTS,
  RFP_CATEGORIES,
  RFP_SELLERS,
  RFP_PARTICIPANTS,
  RFP_PURCHASE_HISTORY,
  RFP_DETAILS,
  RESPONSE_OVERVIEW,
  RESPONSE_CROSS_REFERENCES,
  RESPONSE_OFFER_STRUCTURE,
  RESPONSE_OFFER_PRICING,
  RESPONSE_OFFER_IMPACT,
  OFFER_IMPACT,
  RECOMMENDED_SELLER_INITATED_OFFER,
  CATEGORIES,
  PARTICIPANTS,
  OFFER,
  RESPOND,
  EXECUTE,
  OFFER_HISTORY_SELLER_JS,
  RESPONSE_HISTORY_JS,
  ORGANIZATION_LIST_SELLERS,
  ORGANIZATION_LIST_BUYERS,
  RFP_RESPONSES,
  PARTNERS,
  PURCHASE_PLAN_DETAILS,
  BUYER_EXECUTE,
  OVERVIEW,
  OFFER_STRUCTURE,
  OFFER_PRICING,
  SELLER_AGREEMENT,
  BUYER_AGREEMENT,
  ANALYTICS_SELLER_AGREEMENT,
  ANALYTICS_BUYER_AGREEMENT,
}
